export default __webpack_public_path__ + "2576bca2111cebf100a8a749bc2db0d3.svg";